import React from 'react'
import { BrowserRouter as Router, Route } from "react-router-dom";
import './App.css'
import Home from './pages/Home';
import Create from './pages/Create';
import EditNews from './pages/EditNews';
import Login from './pages/Login';
import PublishedNews from './pages/PublishedNews';
import DraftNews from './pages/DraftNews';
import DeletedNews from './pages/DeletedNews';
import Profile from './pages/Profile';
import Sitemap from './pages/admin/Sitemap';
import Category from './pages/admin/Category';
import Users from './pages/admin/Users';
import Advertisement from './pages/admin/Advertisement';
import Settings from './pages/admin/Settings';
import Logout from './pages/Logout';
import ComingSoon from './pages/ComingSoon';
import Report from './pages/editor/Report';
import UserReport from './pages/editor/UserReport';
import DeleteCache from './pages/DeletedNews';
import AddWebStories from './pages/AddWebStories';
import WebStory from './pages/WebStory';
import WebStoryDraft from './pages/WebStoryDraft';
import WebStoryDeleted from './pages/WebStoryDeleted';
import PortalInfo from './pages/admin/PortalInfo';
import editStory from './pages/editStory';
import Test from './pages/test';
import Adstxt from './pages/admin/Adstxt';
import Feeds from './pages/admin/Feeds';
import PrivateRoute from './routes/PrivateRoute';

const App = () => {

  return (
    <div>

      <Router>
        <Route path="/" exact render={(props) => <Login />} />

        <PrivateRoute path="/category" component={Category} />
        <PrivateRoute path="/users" component={Users} />
        <PrivateRoute path="/advertisement" component={Advertisement} />
        <PrivateRoute path="/portalinfo" component={PortalInfo} />
        <PrivateRoute path="/settings" component={Settings} />
        <PrivateRoute path="/document" component={Category} />

        <PrivateRoute path="/dashboard" component={Home} />
        <PrivateRoute path="/addNews" component={Create} />
        <PrivateRoute path="/editNews/:id" component={EditNews} />
        <PrivateRoute path="/publishedNews" component={PublishedNews} />
        <PrivateRoute path="/draftNews" component={DraftNews} />
        <PrivateRoute path="/deletedNews" component={DeletedNews} />
        <PrivateRoute path="/profile" component={Profile} />
        <PrivateRoute path="/logout" component={Logout} />
        <PrivateRoute path="/sitemap" component={Sitemap} />
        <PrivateRoute path="/report" component={Report} />
        <PrivateRoute path="/userreport" component={UserReport} />
        <PrivateRoute path="/comingSoon" component={ComingSoon} />
        <PrivateRoute path="/deleteCache" component={DeleteCache} />
        <PrivateRoute path="/addStory" component={AddWebStories} />
        <PrivateRoute path="/editStory/:id" component={editStory} />
        <PrivateRoute path="/webstory" component={WebStory} />
        <PrivateRoute path="/webstoryDraft" component={WebStoryDraft} />
        <PrivateRoute path="/webstorydeleted" component={WebStoryDeleted} />
        <PrivateRoute path="/test" component={Test} />
        <PrivateRoute path="/adstxt" component={Adstxt} />
        <PrivateRoute path="/feeds" component={Feeds} />


      </Router>

    </div>
  )
}
export default App;
